import userPreferencesService from './preferences-service';

// Interface for enforcing LocalStorageService types that could need to be refreshed on page load
export interface LocalStorageService {
    RefreshData(): Promise<void>;
}

// Check for flags to refresh local storage data
export async function InitializeLocalStorageRefresh() {
    if ($('#LocalStorageRefreshUserPreferences').val() === "true") {
        await userPreferencesService.RefreshData();
    }
}